import {useTransactionContext} from "./TransactionContext";
import Title from "../../components/atoms/Title";
import SelectBox from "../../components/atoms/SelectBox";
import Loading from "../../components/atoms/Loading";
import React from "react";
import AreaChart from "../../components/transactionPage/AreaChart";
import TransactionLists from "../../components/transactionPage/TransactionList";
import {Toaster} from "react-hot-toast";
import SearchHeader from "../../components/main/SearchHeader";
import Table2 from "../../components/main/Table/Table2";
import {HeaderTransaction} from "../../data/TablesHeader";
import Modalexport from "../../components/transactionPage/Modalexport";
import Pagination from "../../components/main/Pagination";
import {list} from "postcss";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import {useModal} from "../../tools/useModal";
import TransactionChart from "./component/TransactionChart";
import ExportModal from "./component/ExportModal";
import ListsOperations from "../../tools/consts";

const TransactionScreen = () => {

    const {
        listState,
        changePage,
        onSearchBtnClick,
        onDownloadFactorClick
    } = useTransactionContext();


    const {modalState, openModal, closeModal} = useModal();

    return (<div className={'pb-7.5px '}>
            <TransactionChart/>

            <div
                className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
                dir="rtl">
                <TableSearchHeader
                    title={"فهرست تراکـنش‌ها"}
                    number={listState.countAll}
                    placeholder={"جست و جو: شماره تراکنش، شماره سفارش"}
                    countUnit={"تراکنش"}
                    onSearchBtnClick={onSearchBtnClick}
                    hasBtn={true}
                    buttnText={"دریافت خروجی اکسل"}
                    onClick={() => openModal("export")}
                    exportFile={false}
                    path={""}
                />

                {listState.loading ? (
                    <Loading height={"h-66"}/>
                ) : (
                    <>
                        <Table2 headers={HeaderTransaction}
                                tableData={listState.list}
                                emptyText={"تراکنش ثبت شده‌ای یافت نشد."}
                                pageNumber={listState.pageNumber}
                                hasOperation={false}
                                limit={listState.pageLimit}
                                heightEmptyState={'h-168'}/>

                        <ExportModal
                            showModal={modalState.isOpen && modalState.mode === "export"}
                            closeModal={closeModal}
                        />
                        <Pagination
                            changePage={changePage}
                            countAll={listState.countAllPages}
                            currentPage={listState.pageNumber}
                        />
                    </>
                )}
                <Toaster/>
            </div>
        </div>
    )
}
export default TransactionScreen